import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userLanguage } from '$translations/index';
import { useAppDispatch } from '$hooks/index';
import { store } from '../../../store';
import { employerTokenLoginAuthAction } from '../../../store/legacy/auth';
import Spinner from '../../Spinner/Spinner';

const DEFAULT_REDIRECT = '/employer-dashboard/positions';
const FALLBACK_LOGIN_ROUTE = '/client_login';

const isSafeRedirect = (redirect: string | null): redirect is string =>
  !!redirect && redirect.startsWith('/') && !redirect.startsWith('//');

const SsoLoginScreen: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      const hash = window.location.hash.startsWith('#')
        ? window.location.hash.slice(1)
        : window.location.hash;
      const hashParams = new URLSearchParams(hash);
      const idToken = hashParams.get('id_token');
      const redirectParam = hashParams.get('redirect');

      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      );

      const redirect = isSafeRedirect(redirectParam)
        ? redirectParam
        : DEFAULT_REDIRECT;

      if (!idToken) {
        navigate(FALLBACK_LOGIN_ROUTE, { replace: true });
        return;
      }

      await dispatch(employerTokenLoginAuthAction(idToken, userLanguage));

      if (!isMounted) return;

      const { isLoggedIn, serverEmployer } = store.getState().auth;
      navigate(isLoggedIn && serverEmployer ? redirect : FALLBACK_LOGIN_ROUTE, {
        replace: true,
      });
    };

    run();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Spinner />;
};

export default SsoLoginScreen;
